/** Enumeração de tipos de valor de rateio no envio da medição
 * para faturamento.
 */
export enum EApportionmentType {
  MEASUREMENT = "medição",
  READJUSTMENT = "reajuste",
  MEASUREMENTANDREADJUST = "mediçãoMaisReajuste",
}
